<div class="dup-alert" *ngIf="duplicates?.length" role="alert" aria-live="polite">
  <div class="dup-alert__bar"></div>

  <div class="dup-alert__body">
    <div class="dup-alert__icon">
      <mat-icon>content_copy</mat-icon>
    </div>

    <div class="dup-alert__main">
      <div class="dup-alert__title">{{ headline }}</div>
      <div class="dup-alert__sub">
        Every part is listed once on MPS, so buyers see one row and one set of
        quotes against it.
      </div>

      <ul class="dup-alert__list">
        <li *ngFor="let item of duplicates; let i = index"
            [style.animation-delay]="(i * 45) + 'ms'">
          <span class="dup-alert__name">{{ item.name }}</span>
          <span class="dup-alert__reason">{{ item.reason }}</span>
        </li>
      </ul>

      <div class="dup-alert__actions" *ngIf="canAssign">
        <button type="button" class="dup-alert__btn" (click)="assign.emit()">
          <mat-icon>playlist_add_check</mat-icon>
          Assign it to my profile instead
        </button>
      </div>
    </div>

    <button type="button" class="dup-alert__close" (click)="dismiss.emit()"
            aria-label="Dismiss">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
